import { Download, MoreVertical, Share2, Smartphone, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fight-bracket-pro/artifacts/bcn58mfl_WBCGermany.png";

export default function InstallModal({ open, onClose, deferredPrompt }) {
  if (!open) return null;

  const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
    }
    onClose();
  };

  return (
    <div className="modal-backdrop" onClick={onClose} data-testid="install-modal-backdrop">
      <section className="install-modal" onClick={(event) => event.stopPropagation()} data-testid="install-modal">
        <button className="icon-button modal-close" onClick={onClose} aria-label="Schließen" data-testid="install-modal-close-button">
          <X size={20} />
        </button>
        <img className="install-logo" src={LOGO_URL} alt="WBC Germany" data-testid="install-modal-logo" />
        <p className="eyebrow">WBC MUAY THAI</p>
        <h2>APP AUF DEM HANDY SPEICHERN</h2>
        <p className="muted">Für schnellen Zugriff, Vollbild und Turnier-Updates direkt vom Home-Bildschirm.</p>
        <div className="install-steps" data-testid="install-instructions">
          {isIos ? (
            <>
              <Step icon={<Share2 />} number="1" text="Unten auf das Teilen-Symbol tippen." />
              <Step icon={<Smartphone />} number="2" text="„Zum Home-Bildschirm“ auswählen." />
              <Step icon={<Download />} number="3" text="Oben rechts auf „Hinzufügen“ tippen." />
            </>
          ) : (
            <>
              <Step icon={<MoreVertical />} number="1" text="Im Browser-Menü „App installieren“ auswählen." />
              <Step icon={<Download />} number="2" text="Die Installation bestätigen." />
              <Step icon={<Smartphone />} number="3" text="WBC Muay Thai direkt vom Startbildschirm öffnen." />
            </>
          )}
        </div>
        {deferredPrompt && <button className="button primary full" onClick={install} data-testid="install-now-button">JETZT INSTALLIEREN</button>}
        <button className="button primary full" onClick={onClose} data-testid="install-modal-confirm-close-button">ALLES KLAR, SCHLIESSEN</button>
        <button className="text-button" onClick={onClose} data-testid="install-modal-later-button">SPÄTER ERINNERN</button>
      </section>
    </div>
  );
}

function Step({ icon, number, text }) {
  return <div className="install-step"><span className="step-icon">{icon}</span><span className="step-number">{number}</span><p>{text}</p></div>;
}
